import './contacts.scss';
import MagneticLink from "../shared/magnetic-link";
import React from "react";

const ContactsBanner: React.FC = () => {
    const contactsLink1 = {
        firstCol: [
            {
                name: "Instagram",
                link: "https://www.instagram.com/alessandroserra97/"
            },
            {
                name: "Linkedin",
                link: "https://it.linkedin.com/in/alessandroserra97"
            },
            {
                name: "Email",
                link: "mailto: alessandro.serra.8@gmail.com"
            },
        ],
        secondCol:[
            {
                name: "Resume",
                link: "/Alessandro_Serra_-_Resume.pdf"
            },
        ]
    }
  return (
      <>
          <section className='contact-page text-light p-6 pt-8 lg:pb-10 flex flex-col justify-between'>
              <div className='grid grid-cols-12 gap-2 lg:gap-6'>
                  <div className='col-span-12 lg:col-span-10 lg:col-start-2'>
                      <h3 className="overflow-hidden">
                          {"Let's keep in".split("").map((char, index) => (
                              <span
                                  className="animate-text-reveal inline-block [animation-fill-mode:backwards]"
                                  key={`${char}-${index}`}
                                  style={{ animationDelay: `${index * 0.06}s` }}
                              >
                                {char === " " ? "\u00A0" : char}
                              </span>
                          ))}
                      </h3>
                      <h3 className="overflow-hidden contact-label">
                          {"contact!".split("").map((char, index) => (
                              <span
                                  className="animate-text-reveal inline-block [animation-fill-mode:backwards]"
                                  key={`${char}-${index}`}
                                  style={{ animationDelay: `${index * 0.06}s` }}
                              >
                                {char === " " ? "\u00A0" : char}
                              </span>
                          ))}
                      </h3>
                      <p className={'text-light-70'}>I'm available for work.</p>
                  </div>
              </div>
              <div className='grid grid-cols-12 gap-2 lg:gap-6 mt-8 items-end'>
                  <div className='col-span-12 lg:col-span-4 lg:col-start-5'>
                      <ul className={'social-col'}>
                          {contactsLink1.firstCol.map(social=>(
                              <>
                                  <li>
                                      <MagneticLink text={social.name} url={social.link}/>
                                  </li>
                              </>
                          ))}
                      </ul>
                      <ul className={'social-col lg:hidden'}>
                          {contactsLink1.secondCol.map(social=>(
                              <>
                                  <li>
                                      <MagneticLink text={social.name} url={social.link}/>
                                  </li>
                              </>
                          ))}
                      </ul>
                  </div>
                  <div className='col-span-4 hidden lg:block'>
                      <ul className={'social-col'}>
                          {contactsLink1.secondCol.map(social=>(
                              <>
                                  <li>
                                      <MagneticLink text={social.name} url={social.link}/>
                                  </li>
                              </>
                          ))}
                      </ul>
                  </div>
              </div>
          </section>

      </>
  );
};

export default ContactsBanner;